import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reject-quote-modal',
  templateUrl: './reject-quote-modal.component.html',
  styleUrls: ['./reject-quote-modal.component.css']
})
export class RejectQuoteModalComponent implements OnInit {

  title: string;
  message: string;
  
  rejectForm = new FormGroup({
    reason: new FormControl(null, { validators: Validators.required }),    
  });

  constructor(public dialogRef: MatDialogRef<RejectQuoteModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RejectQuoteModalComponent) {
    this.title = data.title;
    this.message = data.message;
  }

  ngOnInit() {
  }

  onConfirm(): void {
    if (this.rejectForm.valid){
      let data = {
        reason: this.rejectForm.controls['reason'].value,
        status: true
      }
      this.dialogRef.close(data);
    } else {
      //this.dialogRef.close(true);
    }
    
  }

  onDismiss(): void {
    let data = {
      reason: null,
      status: false
    }
    this.dialogRef.close(data);
  }

}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
 export class RejectQuoteModalModel {
  constructor(public title: string, public message: string) {
  }
}